
<main class="screen">
  <app-navbar></app-navbar>
  <div class="dashboard-container">
    <div class="header-section">
      <div class="header-left">
        <h1 class="dashboard-title">Smart Meter Readings</h1>
      </div>

      <div class="header-right">
        <button class="show-current-btn"
                (click)="showCurrentData()"
                [disabled]="isLoading || isShowingToday">
          Show current data
        </button>

        <div class="date-picker-badge">
          <button class="nav-btn" (click)="prevDay()" [disabled]="isLoading">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>

          <div class="date-display" (click)="picker.open()" style="cursor: pointer;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2.2"
                 stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
              <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"/>
            </svg>
            <span>{{ selectedDate.toJSDate() | date:'dd MMMM yyyy' }}</span>
            <input matInput [matDatepicker]="picker" 
                   [value]="selectedDate"
                   (dateChange)="onDateChange($event)"
                   [max]="maxDate"
                   style="position: absolute; opacity: 0; width: 0; height: 0; pointer-events: none;">
            <mat-datepicker #picker panelClass="premium-calendar"></mat-datepicker>
          </div>

          <button class="nav-btn" (click)="nextDay()" [disabled]="isLoading || selectedDate >= maxDate">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="lag-note" *ngIf="showCurrentDataNote">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="16" x2="12" y2="12"/>
        <line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
      <span>The reading updates periodically and there can be lag.</span>
    </div>

      <section class="panel">
      
        <div *ngIf="isLoading || centerMessage" class="center-message-wrapper">
          <div class="center-message">
            <div *ngIf="isLoading" class="spinner" aria-hidden="true"></div>
            <div class="message-text">
              {{ isLoading ? "Loading data…" : centerMessage }}
            </div>
          </div>
        </div>

      
        <div class="columns" *ngIf="!isLoading">
          <!-- Prosumers -->
          <section class="board">
            <div class="board-head-pill prosumer-pill">Prosumers</div>

            <div class="meter-list-box">
               <div class="table-head">
                <div class="col col-no text-center">No.</div>
                <div class="col col-name text-center">Customer Name</div>
                <div class="col col-val text-center">Solar Generation (KWh)</div>
                <div class="col col-val text-center">Import (KWh)</div>
                <div class="col col-val text-center">Export (KWh)</div>
              </div>

              <div *ngIf="prosumers.length === 0" class="no-data-msg">
                No prosumer data for this date.
              </div>

              <div class="reading-row" *ngFor="let p of prosumers; index as i">
                <div class="col col-no">{{ (i + 1) | number: '2.0-0' }}</div>
                <div class="col col-name-val">{{ p.name }}</div>
                <div class="col col-val">{{ formatEnergy(p.solar_generation_kwh) }}</div>
                <div class="col col-val">{{ formatEnergy(p.import_kwh) }}</div>
                <div class="col col-val"
                     [class.export-exceeded]="p.export_kwh !== undefined && p.export_kwh !== 0
                                              && p.solar_generation_kwh !== undefined && p.solar_generation_kwh !== 0
                                              && p.export_kwh > p.solar_generation_kwh">
                  {{ formatEnergy(p.export_kwh) }}
                </div>
              </div>
            </div>
          </section>

          <!-- Consumers -->
          <section class="board">
            <div class="board-head-pill consumer-pill">Consumers</div>

            <div class="meter-list-box">
              <div class="table-head table-head--consumer">
                <div class="col col-no text-center">No.</div>
                <div class="col col-name text-center">Customer Name</div>
                <div class="col col-val text-center">Import (KWh)</div>
              </div>

              <div *ngIf="consumers.length === 0" class="no-data-msg">
                No consumer data for this date.
              </div>

              <div class="reading-row reading-row--consumer" *ngFor="let c of consumers; index as i">
                <div class="col col-no">{{ (i + 1) | number: '2.0-0' }}</div>
                <div class="col col-name-val">{{ c.name }}</div>
                <div class="col col-val">{{ formatEnergy(c.import_kwh) }}</div>
              </div>
            </div>
          </section>
        </div>
      </section>
    <div class="dashboard-footer">Powered By Hygge Energy</div>
  </div>
</main>
